import { render, staticRenderFns } from "./WithHoldingTax.vue?vue&type=template&id=e7fcb4f6&"
import script from "./WithHoldingTax.vue?vue&type=script&lang=js&"
export * from "./WithHoldingTax.vue?vue&type=script&lang=js&"
import style0 from "./WithHoldingTax.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QSelect,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QSelect,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn})
